<template>
 
   
      <v-container 
        fluid

        fill-height
        class="loginOverlay"
        id="login_container"
      >
        <v-layout
         grid-list-xl
            wrap
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm12
            md4
          >
            <v-card  class="elevation-0" >
               
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title align-center class="text-center">Nova Música Gospel</v-toolbar-title>
                <v-spacer></v-spacer>
               
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Email"
                    name="email"
                    prepend-icon="person"
                    type="text"
                    v-model="credentials.email"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Senha"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    v-model="credentials.password"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="authenticate()" color="primary">Entrar</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
 
 
</template>
<style>

#login_container {
  background-image: url("https://images.unsplash.com/photo-1497733942558-e74c87ef89db?dpr=1&auto=compress,format&fit=crop&w=1650&h=&q=80&cs=tinysrgb&crop=");
  background-size: cover;
  overflow:hidden;
}

.loginOverlay {
  background:rgba(33,150,243,0.3);
}

</style>

<script>
import {mapActions} from 'vuex';
import AuthService from '../app/Rest/auth';
const authService = AuthService.build();


export default {
    data(){
        return {
            credentials: { email:'',password:''},
            source: "",
        }
    },
    methods:{
        ...mapActions([
            'userAuthenticateData'
        ]),
        authenticate () {
            authService.login(this.credentials).then(e =>{                
                if(e.token && e.token.access_token.split('.').length === 3){
                    this.userAuthenticateData(e);
                   
                    this.$router.push({name:'dashboard'});
                }
            }).catch( e =>{
                //@todo colocar um dialog aqui
            });
        }
    }   
}
</script>

